import { ReactNode } from 'react'
import styles from './Banner.module.css'
import { InfoIcon } from '../icons/Info'
import { WarningIcon } from '../icons/Warning'

interface Props {
  children?: ReactNode
  theme: string
}

function Banner({
  children,
  theme
}: Props) {

  const getIcon = (theme: string) => {
    switch (theme) {
      case 'info':
        return <InfoIcon className={styles.icon} color='currentColor'/>
      case 'warning':
        return <WarningIcon className={styles.icon} color='currentColor'/>
      default:
        return 
    }
  }

  const getTheme = (theme: string) => {
    switch (theme) {
      case 'info':
        return {
          backgroundColor: '#F6F6F6',
          color: 'var(--text)',
        }
      case 'warning':
        return {
          backgroundColor: '#FFE5E5',
          color: 'var(--redMid)',
        }
      default:
        return 
    }
  }
  
  return (
    <div className={styles.bannerContent} style={getTheme(theme)}>
      {getIcon(theme)}
      {children}
    </div>
  )
}

export default Banner